import api from '../api'

export default {

  clerks: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/clerks?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  createGetData: async ()=> {
    return api.get('api/clerks/create')
  },

  create: async clerk => {
    return api.post('api/clerks', clerk)
  },

  get: async id => {
    return api.get('api/clerks/' + id)
  },

  update: async (id,clerk) => {
    return api.put('api/clerks/' + id, clerk)
  },

  delete: async id => {
    return api.delete('api/clerks/' + id)
  }
}
